module.exports = __webpack_public_path__ + "img/architect.c483f67.svg";